import React, { FunctionComponent, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import apis from '../../apis';
import { StudentPHIAll } from '../../model';
import { toast } from 'react-toastify';

type Props = {
  student: StudentPHIAll;
  onApiError: (e: any) => void;
  onValueUpdated: () => void;
  onValueDelete?: () => void;
};

export const RemarkSection: FunctionComponent<Props> = ({
  student,
  onApiError,
  onValueUpdated,
}) => {
  const [inputing, setInputing] = useState(false);
  const [remarkValue, setRemarkValue] = useState<string>(student.remark ?? '');

  function updateStudentRemark() {
    toast
      .promise(apis.SetStudentRemark(student.pid, remarkValue ?? ''), {
        pending: '資料更新中......',
        success: '更新成功！',
      })
      .then(() => {
        onValueUpdated();
        setInputing(false);
      })
      .catch(onApiError);
  }

  return (
    <>
      <div className="sheet-title">
        學生備註 : (字數上限2000字)
        {inputing ? (
          <>
            <Button
              key="cell-edit"
              className="border-0 px-2 py-1"
              variant="outline-primary"
              size="sm"
              disabled={remarkValue.length > 2000}
              onClick={() => {
                updateStudentRemark();
              }}
            >
              <span className="feather icon-save" />
            </Button>
            <Button
              key="cell-x"
              className="border-0 px-2 py-1 m-0 mr-1"
              variant="outline-danger"
              size="sm"
              onClick={() => {
                setInputing(false);
                setRemarkValue(student?.remark ?? '');
              }}
            >
              <span className="feather icon-x" />
            </Button>
          </>
        ) : (
          <Button
            key="cell-save"
            className="border-0 px-2 py-1"
            variant="outline-primary"
            size="sm"
            onClick={() => {
              setInputing(true);
            }}
          >
            <span className="feather icon-edit" />
          </Button>
        )}
      </div>
      <Form.Control
        as="textarea"
        rows={20}
        disabled={!inputing}
        value={remarkValue}
        onChange={(e) => setRemarkValue(e.target.value)}
      />
      <div className="text-right">
        目前字數：{remarkValue.length} / 2000{' '}
        {remarkValue.length > 2000 ? (
          <span className="text-danger">超過字數上限</span>
        ) : null}
      </div>
    </>
  );
};
